import { render, staticRenderFns } from "./Stowage.vue?vue&type=template&id=67287af6&"
import script from "./Stowage.vue?vue&type=script&lang=js&"
export * from "./Stowage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports